"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIFileAttachment;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _colors = require("HubStyleTokens/colors");

var _misc = require("HubStyleTokens/misc");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _UICloseButton = _interopRequireDefault(require("../button/UICloseButton"));

var _Small = _interopRequireDefault(require("../elements/Small"));

var _UIIcon = _interopRequireDefault(require("../icon/UIIcon"));

var _UIMedia = _interopRequireDefault(require("../layout/UIMedia"));

var _UIMediaBody = _interopRequireDefault(require("../layout/UIMediaBody"));

var _UIMediaLeft = _interopRequireDefault(require("../layout/UIMediaLeft"));

var _UITruncateString = _interopRequireDefault(require("../text/UITruncateString"));

var customRenderer = _interopRequireWildcard(require("../utils/propTypes/customRenderer"));

var _tshirtSize = require("../utils/propTypes/tshirtSize");

var _Styles = require("../utils/Styles");

var SIZE_VALUES = {
  fontSize: '12px',
  sm: {
    iconFont: '16px',
    previewWidth: '16px'
  },
  lg: {
    iconFont: '32px',
    previewWidth: '32px'
  }
};

var StyledAttachment_Children = _styledComponents.default.div.withConfig({
  displayName: "UIFileAttachment__StyledAttachment_Children",
  componentId: "f94jcs-0"
})(["margin:0;bottom:0;left:0;position:absolute;right:0;top:0;"]);

var StyledAttachment_Media = (0, _styledComponents.default)(_UIMedia.default).withConfig({
  displayName: "UIFileAttachment__StyledAttachment_Media",
  componentId: "f94jcs-1"
})(["position:relative;max-width:100%;min-width:0;line-height:", ";"], function (_ref) {
  var size = _ref.size;
  return size === 'sm' && SIZE_VALUES.fontSize;
});
var StyledAttachment_Preview = (0, _styledComponents.default)(_UIMediaLeft.default).withConfig({
  displayName: "UIFileAttachment__StyledAttachment_Preview",
  componentId: "f94jcs-2"
})(["align-items:center;display:flex;flex-basis:auto;flex-shrink:0;", ";"], function (_ref2) {
  var size = _ref2.size;
  return (0, _styledComponents.css)(["", " max-height:", ";width:", ";> *{max-height:", ";max-width:", ";}"], (0, _Styles.setFontSize)(SIZE_VALUES[size].iconFont), SIZE_VALUES[size].previewWidth, SIZE_VALUES[size].previewWidth, SIZE_VALUES[size].previewWidth, SIZE_VALUES[size].previewWidth);
});
StyledAttachment_Preview.displayName = 'StyledAttachment_Preview';
var StyledAttachment_Info = (0, _styledComponents.default)(_UIMediaBody.default).withConfig({
  displayName: "UIFileAttachment__StyledAttachment_Info",
  componentId: "f94jcs-3"
})(["display:flex;flex-direction:column;justify-content:center;line-height:1rem;width:100%;&&{flex-basis:auto;margin-left:", ";}", ";"], function (_ref3) {
  var size = _ref3.size;
  return size === 'sm' && '8px';
}, function (_ref4) {
  var size = _ref4.size;
  if (size === 'sm') return (0, _styledComponents.css)(["align-items:center;flex-direction:row;white-space:nowrap;"]);else if (size === 'lg') return (0, _styledComponents.css)(["min-height:2rem;"]);
  return null;
});
var FileInfo = (0, _styledComponents.default)(function (_ref5) {
  var className = _ref5.className,
      fileInfo = _ref5.fileInfo,
      size = _ref5.size;
  return fileInfo ? _react.default.createElement(_Small.default, {
    className: className,
    use: "help"
  }, size === 'sm' && '(', fileInfo, size === 'sm' && ')') : null;
}).withConfig({
  displayName: "UIFileAttachment__FileInfo",
  componentId: "f94jcs-4"
})(["&&{font-weight:", ";line-height:inherit;margin-left:", ";}"], _misc.WEB_FONT_REGULAR_WEIGHT, function (_ref6) {
  var size = _ref6.size;
  return size === 'sm' && '1ch';
});
var StyledAttachment_Close = (0, _styledComponents.default)(function (_ref7) {
  var __attachmentSize = _ref7.attachmentSize,
      rest = (0, _objectWithoutProperties2.default)(_ref7, ["attachmentSize"]);
  return _react.default.createElement(_UICloseButton.default, rest);
}).withConfig({
  displayName: "UIFileAttachment__StyledAttachment_Close",
  componentId: "f94jcs-5"
})(["flex-shrink:0;color:", ";right:10px;top:10px;vertical-align:text-top;", ";"], _colors.EERIE, function (_ref8) {
  var attachmentSize = _ref8.attachmentSize;
  return attachmentSize === 'sm' && (0, _styledComponents.css)(["align-self:center;margin-left:auto;margin-right:0;position:static;margin-left:8px;&::after{left:auto;margin-left:12px;}"]);
});
StyledAttachment_Close.displayName = 'StyledAttachment_Close';

var StyledAttachment = _styledComponents.default.div.withConfig({
  displayName: "UIFileAttachment__StyledAttachment",
  componentId: "f94jcs-6"
})(["display:", ";padding:", ";", ";", ";background-color:", ";border:1px solid ", ";color:", ";font-weight:", ";max-width:100%;position:relative;justify-content:space-between;padding-right:", ";"], function (_ref9) {
  var size = _ref9.size;
  return size === 'sm' ? 'flex' : 'inline-flex';
}, function (_ref10) {
  var size = _ref10.size;
  return size === 'sm' ? '8px 12px' : '12px';
}, (0, _Styles.setBorderRadius)(), (0, _Styles.setFontSize)(SIZE_VALUES.fontSize), function (_ref11) {
  var use = _ref11.use;
  return use === 'on-dark' ? _colors.OLAF : _colors.GYPSUM;
}, _colors.KOALA, function (_ref12) {
  var processing = _ref12.processing;
  return processing ? _colors.EERIE : _colors.HEFFALUMP;
}, _misc.WEB_FONT_DEMI_BOLD_WEIGHT, function (_ref13) {
  var size = _ref13.size;
  return size === 'lg' && '32px';
});

var DefaultFilePreview = function DefaultFilePreview(_ref14) {
  var fileType = _ref14.fileType;
  return _react.default.createElement(_UIIcon.default, {
    className: "align-self-end",
    name: fileType === 'application/pdf' ? 'pdfFile' : 'file'
  });
};

DefaultFilePreview.propTypes = {
  fileType: _propTypes.default.string
};

function UIFileAttachment(props) {
  var closeable = props.closeable,
      use = props.use,
      size = props.size,
      children = props.children,
      renderPreview = props.renderPreview,
      fileName = props.fileName,
      fileInfo = props.fileInfo,
      __fileType = props.fileType,
      onCloseClick = props.onCloseClick,
      processing = props.processing,
      rest = (0, _objectWithoutProperties2.default)(props, ["closeable", "use", "size", "children", "renderPreview", "fileName", "fileInfo", "fileType", "onCloseClick", "processing"]);
  var shorthandSize = (0, _tshirtSize.toShorthandSize)(size);
  var renderedPreview = customRenderer.render(renderPreview, props, {
    mergeType: 'none'
  });

  var renderedFileInfo = _react.default.createElement(FileInfo, {
    size: shorthandSize,
    fileInfo: fileInfo
  });

  if (use === 'processing') {
    _devLogger.default.warn({
      message: 'UIFileAttachment: `use="processing"` is deprecated. Set `processing={true}` instead.',
      key: 'UIFileAttachment: processing',
      url: 'https://git.hubteam.com/HubSpot/UIComponents/issues/7991#issuecomment-1176756'
    });
  }

  return _react.default.createElement(StyledAttachment, Object.assign({}, rest, {
    processing: processing || use === 'processing',
    size: shorthandSize,
    use: use
  }), children && _react.default.createElement(StyledAttachment_Children, {
    size: shorthandSize
  }, children), _react.default.createElement(StyledAttachment_Media, {
    size: shorthandSize
  }, _react.default.createElement(StyledAttachment_Preview, {
    size: shorthandSize
  }, renderedPreview), _react.default.createElement(StyledAttachment_Info, {
    size: shorthandSize
  }, shorthandSize === 'sm' ? _react.default.createElement(_UITruncateString.default, {
    useFlex: true,
    fixedChildren: renderedFileInfo
  }, fileName) : _react.default.createElement(_UITruncateString.default, {
    useFlex: true
  }, fileName), shorthandSize !== 'sm' && renderedFileInfo)), closeable && _react.default.createElement(StyledAttachment_Close, {
    className: "private-attachment__close",
    onClick: onCloseClick,
    size: "sm",
    attachmentSize: shorthandSize
  }));
}

UIFileAttachment.propTypes = {
  children: _propTypes.default.node,
  closeable: _propTypes.default.bool.isRequired,
  onCloseClick: _propTypes.default.func,
  processing: _propTypes.default.bool.isRequired,
  use: _propTypes.default.oneOf(['default', 'on-dark']),
  size: _propTypes.default.oneOfType([(0, _tshirtSize.propTypeForSizes)(['sm', 'lg']), _propTypes.default.oneOf(['auto'])]).isRequired,
  fileName: _propTypes.default.node.isRequired,
  fileInfo: _propTypes.default.node,
  fileType: _propTypes.default.string,
  renderPreview: customRenderer.propType
};
UIFileAttachment.defaultProps = {
  closeable: false,
  processing: false,
  use: 'default',
  size: 'lg',
  renderPreview: DefaultFilePreview
};
UIFileAttachment.displayName = 'UIFileAttachment';
module.exports = exports.default;